import React from 'react';
import './PageHeader.css';
import arrowBackIcon from './icons/arrow-back-black.svg'
import {Link, useNavigate} from "react-router-dom";
import {Avatar, Dropdown} from "antd";
import {
  CalendarOutlined,
  CommentOutlined, CrownOutlined, HighlightOutlined, NotificationOutlined, SisternodeOutlined,
  UserDeleteOutlined,
  UserOutlined,
  UserSwitchOutlined
} from "@ant-design/icons";
import {useDispatch, useSelector} from "react-redux";
import {useTranslation} from "react-i18next";
import crownIcon from "../../pages/icons/crown.png";
import {jwtDecode} from "jwt-decode";
import {authActions} from "../../store";
import {useOrganization} from "../../context/organizationContext";
import NotificationDrawer from "../Drawers/NotificationDrawer";
//h
const PageHeader = ({ title, onBackClick }) => {
  const { t } = useTranslation();
  const org = useOrganization();
  const user = useSelector((obj) => obj.auth.user);
  const navigate = useNavigate();
  const sid = user ? jwtDecode(JSON?.parse(localStorage?.getItem("user"))?.accessToken)?.subscriptionLevel?.id : false;
  console.log(sid);
  const dispatch = useDispatch();

  const items = [
    {
      condition: true,
      key: 'username',
      label: user?.name,
      disabled: true,
    },
    {
      condition: true,
      type: 'divider',
    },
    {
      condition: true,
      key: 'profile',
      label: <Link to={'/profile'}>{t("home.profile")}</Link>,
      icon: <UserSwitchOutlined />,
    },
    {
      condition: true,
      key: 'postsCalendar',
      label: <Link to={'/publication-calendar'}>{t("home.postsCalendar")}</Link>,
      icon: <CalendarOutlined />,
    },
    {
      condition: (org?.organization?.moderatorExist && user?.moderatorOrg),
      key: 'alertsManagement',
      label: <Link to={'/alerts-management'}>{t("home.alertsManagement")}</Link>,
      icon: <NotificationOutlined />,
    },
    {
      condition: false, // Скрываем кнопку модерации из меню
      key: 'moderation',
      label: <Link to={'/moderation'}>{t("home.moderation")}</Link>,
      icon: <HighlightOutlined />,
    },
    {
      condition: true,
      key: 'analytics',
  label: <Link to={'/analytics'}>{t('analytics.menu')}</Link>,
      icon: <HighlightOutlined />,
    },
    {
      condition: true,
      key: 'guideline',
      label: <Link to={'/guideline'}>{t("home.guideline")}</Link>,
      icon: <SisternodeOutlined />,
    },
    {
      condition: true,
      key: 'support',
      label: <Link to={'/support'}>{t("home.support")}</Link>,
      icon: <CommentOutlined />,
    },
    // {
    //   condition: true,
    //   key: 'achievements',
    //   label: <Link to={'/achievements'}>{t("home.achievements")}</Link>,
    //   icon: <CrownOutlined />,
    // },
    {
      condition: true,
      key: 'logoutConfirm',
      label: <div onClick={()=> {
        if (window.confirm(t('home.logoutConfirm'))) {
          dispatch(authActions.logout())
        }
      }}>{t("home.logout")}</div>,
      icon: <UserDeleteOutlined />,
    },
  ];

  return (
    <div className="header-container">

      <div className='flex items-center'>
        <button
            className="back-button"
            onClick={()=>{
          onBackClick ? onBackClick(): navigate(-1)
        }}>
          <img width={35} src={arrowBackIcon} alt="" /> {/* Ideally use an SVG or icon here */}
          <h6 className='header-title'>{title}</h6>
        </button>
        {/* Add additional status bar icons if needed */}
      </div>

      <div className='flex items-center gap-5'>

        <NotificationDrawer/>

        {user && (
          <div className='relative'>
            {!!sid && <img className='w-5 h-5 absolute -top-2 -right-2 z-10 !bg-transparent pointer-events-none' src={`${crownIcon}`} alt="premium"/>}
            <Dropdown placement='bottomRight' menu={{ items: items.map((item)=> {
              if (item.condition) {
                let obj = item;
                delete obj.condition
                return obj
              }
              }) }}>
              <a onClick={e => e.preventDefault()}>
                <Avatar className='cursor-pointer' size={35} style={{ backgroundColor: '#cab9f2', color: '#000' }} icon={<UserOutlined />} />
              </a>
            </Dropdown>

          </div>
        )}
      </div>

    </div>
  );
};

export default PageHeader;
